import React from "react";
import { Box, Breadcrumbs, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useUpdateAuthToken from "../../hooks/useUpdateAuthToken";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import ItemCreateForm from "./ItemCreateForm";
import { ITEM_CREATE_TEXTS, ITEM_LIST_TEXTS } from "../shared/constants";
import { CommonBoxStyles } from "../shared/styledComponents";

export const CreateItemPage: React.FC = () => {
  useUpdateAuthToken();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PageLayout showSearch={false}>
      <CommonBoxStyles>
        <Box p={2}>
          <Breadcrumbs sx={{ mb: 1 }}>
            <Link
              component="button"
              underline="hover"
              color="inherit"
              onClick={() => navigate("/item-maintenance")}
            >
              {ITEM_LIST_TEXTS.breadcrumb}
            </Link>
            <Typography color="text.primary">{ITEM_CREATE_TEXTS.pageTitle}</Typography>
          </Breadcrumbs>
          <Typography variant={isSmall ? "h6" : "h5"} fontWeight="bold" color="text.primary">
            {ITEM_CREATE_TEXTS.pageTitle}
          </Typography>
        </Box>
        <Box p={2}>
          <ItemCreateForm />
        </Box>
      </CommonBoxStyles>
    </PageLayout>
  );
};

export default CreateItemPage;
